import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';

class Pricing extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { trans } = this.props;
        return (
            <div>
                <Header trans={trans}
                    active="pricing"
                    style={{backgroundImage: 'url(/static/images/pricing-banner.jpg)'}}
                    title="Pricing Plans"
                    body="We give you x2 value for the same prices compared to other relevant chatbot platforms"
                />
                    <div className="section tint">
                        <div className="container w-container">
                            <div className="pricing-features-row w-row">
                                <div style={{opacity: 1, transform: "translateX(0px) translateY(0px) translateZ(0px)", display: "block", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-load" className="pricing-features-column w-col w-col-6">
                                    <div className="features-pricing-block">
                                        <div className="pricing-content-block first">
                                            <div className="color-pricing-title">{trans('Starter Plan')}</div>
                                            <div className="pricing-price-title">{trans('Free')}</div>
                                        </div>
                                        <div className="pricing-content-block">
                                            <p className="pricing-decription">
                                                {trans('Free to use')} <br />{trans('Full features accessible and no hidden cost')}
                                            </p>
                                        </div>
                                        <div className="pricing-content-block">
                                            <ul className="feature-list w-list-unstyled">
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Messages')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Chat Users')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Broadcasts')}</div>
                                                </li>
                                                <li src="https://uploads-ssl.webflow.com/59fed69e519aa50001467587/5b3725455b093e5ea4ec8035_padlock%20%281%29.png" className="feature-list-item"><img src="/static/images/5b3724f1df51e71c03f96c48_checked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Limited')}</div>
                                                    <div className="pricing-feature-title">{trans('Sequences')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b3724f1df51e71c03f96c48_checked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">20</div>
                                                    <div className="pricing-feature-title">{trans('Tags')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b3724f1df51e71c03f96c48_checked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">20</div>
                                                    <div className="pricing-feature-title">{trans('CMS Items')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b3724f1df51e71c03f96c48_checked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">500</div>
                                                    <div className="pricing-feature-title">{trans('Subscribers')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b3725455b093e5ea4ec8035_padlock%25201.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">HansaBot </div>
                                                    <div className="pricing-feature-title">{trans('Brand Persisted')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b3725455b093e5ea4ec8035_padlock%25201.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Community')}</div>
                                                    <div className="pricing-feature-title">{trans('Support')}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="pricing-content-block">
                                            <a href="#" target="_blank" className="button pricing-start w-button">{trans('Get Started')}</a>
                                        </div>
                                    </div>
                                </div>
                                <div style={{opacity: 1, display: "block", transition: "opacity 500ms ease 0s"}} data-ix="fade-in-on-load-2" className="pricing-features-column w-col w-col-6">
                                    <div className="features-pricing-block">
                                        <div className="pricing-content-block second">
                                            <div className="color-pricing-title pricing-pro">{trans('PRO Plan')}</div>
                                            <div className="pricing-price-title">{trans('starts at')} {trans('$')}10/{trans('month')}</div>
                                        </div><div className="pricing-content-block">
                                        <p className="pricing-decription">
                                            {trans('Unlocks every feature caps in one go')} <br />{trans('Pay only for what you need')}
                                        </p>
                                        </div>
                                        <div className="pricing-content-block">
                                            <ul className="feature-list w-list-unstyled">
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png"
                                                        className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Messages')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Chat Users')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png"
                                                        className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Broadcasts')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png"
                                                        className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Sequences')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png"
                                                        className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('Tags')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Unlimited')}</div>
                                                    <div className="pricing-feature-title">{trans('CMS Items')}</div>
                                                </li>
                                                <li className="feature-list-item"><img src="/static/images/5b372612f23df38daf6e0396_unlocked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Uncapped')}</div>
                                                    <div className="pricing-feature-title">{trans('Subscribers')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b372612f23df38daf6e0396_unlocked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('Custom')}</div>
                                                    <div className="pricing-feature-title">{trans('Brand Unlocked')}</div>
                                                </li>
                                                <li className="feature-list-item">
                                                    <img src="/static/images/5b372612f23df38daf6e0396_unlocked.png" className="pricing-list-icon" />
                                                    <div className="pricing-feature-title bold">{trans('VIP Direct Chat')} </div>
                                                    <div className="pricing-feature-title">{trans('Support')}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="pricing-content-block">
                                            <a href="#" target="_blank" className="button pricing-start purple w-button">{trans('UPGRADE')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-container">
                            <div className="price-slider-wrapper">
                                <div id="price-display" className="price-display">
                                    <div className="price-slide-result">{trans('Engage')}</div>
                                    <div className="price-slide-result hide-small"> {trans('up to')} </div>
                                    <div id="subscriber-count" className="price-slide-result number">1,000</div>
                                    <div className="price-slide-result"> {trans('subscribers')}</div>
                                    <div className="price-slide-result hide-small">{trans('for just')}</div>
                                    <div id="subscriber-price" className="price-slide-result number">{trans('$')}10</div>
                                    <div className="price-slide-result">{trans('per month')}</div>
                                </div>
                                <div id="slider-range" className="sliders">
                                </div>
                            </div>
                            <p className="legal-quote">
                                <strong>{trans('What is Subscriber')}<br /></strong>{trans('Subscribers also known as audience are end users that can be managed and tracked by you or your chatbot They can be tagged, broadcasted, analysed and inboxed')}.<br /><br />
                                <strong>{trans('What is the difference between subscriber and chat user')}<br /></strong>
                                {trans('We do not limit the number of people who can chat or interact with your chatbot However only subscribers that are within your plan cap can be tracked and shown in our platform')}
                            </p>
                        </div>
                    </div>
                    <div className="image-section get-the-app">
                        <div className="image-section-overlay">
                            <div className="container w-container">
                                <div className="image-section-overlay-block">
                                    <h2 className="section-title">
                                        {trans('Need A Starting Point')}
                                    </h2>
                                    <div className="section-description">
                                        {trans('Checkout professional templates contributed by HansaBot and other developers around the world')}
                                    </div>
                                    <a href="#" className="button purple w-button">{trans('Template Marketplace')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section contact-us-section">
                        <div className="container centered w-container">
                            <div className="section-title-wrapper full-centered contact">
                                <h2 className="section-title section-title-on-gray">
                                    {trans('Need Your Chatbot Custom Built')}
                                </h2>
                                <div className="section-description section-description-on-gray">
                                    {trans('Get in touch with us to discuss the best options for your business')}
                                </div>
                            </div>
                            <a href="#" className="button w-button">{trans('Contact us now')}</a>
                        </div>
                    </div>







































                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Pricing);






// WEBPACK FOOTER //
// ./src/pages/Pricing.js